import React from 'react';
import '../assetDetailsCard/assetDetailsCard.css';

const payloadTimeStyle = { justifyContent: 'center', marginTop: '-4px', marginBottom: '8px' };

const ScanSummaryCard = React.memo(({ bleSpan }) => {
    if (!bleSpan) return null;

    const zoneRssi = (count, rssi) => (count > 0 && rssi != null ? `${rssi}` : '-');
    const totalScanned = (bleSpan.zoneACount ?? 0) + (bleSpan.zoneBCount ?? 0) + (bleSpan.zoneCCount ?? 0);

    return (
        <>
            <div className="scan-summary-title">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M5.24 6.5a16 16 0 0 1 13.52 0" />
                    <path d="M7.35 11.03a11 11 0 0 1 9.3 0" />
                    <path d="M9.46 15.56a6 6 0 0 1 5.07 0" />
                    <line x1="12" y1="20" x2="12.01" y2="20" />
                </svg>
                <span className="scan-summary-title-text">Scan Summary</span>
                <span className="scan-summary-count-badge">{totalScanned}</span>
            </div>
            {bleSpan.payloadTime?.value != null && (
                <div className="asset-device-detail-container" style={payloadTimeStyle}>
                    {`Payload time: ${new Date(bleSpan.payloadTime.value).toLocaleString([], { dateStyle: 'short', timeStyle: 'medium' })}`}
                </div>
            )}
            <div className="scan-summary-zones-row">
                <div className="scan-summary-zone-item">
                    <span className="scan-summary-dot scan-summary-dot--green" />
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">{`Count: ${bleSpan.zoneACount ?? '-'}`}</div>
                        <div className="asset-device-detail-container">{`Zone A (1-3m) · RSSI: ${zoneRssi(bleSpan.zoneACount, bleSpan.zoneAAvgRssi)}`}</div>
                    </div>
                </div>
                <div className="scan-summary-zone-item">
                    <span className="scan-summary-dot scan-summary-dot--amber" />
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">{`Count: ${bleSpan.zoneBCount ?? '-'}`}</div>
                        <div className="asset-device-detail-container">{`Zone B (5-10m) · RSSI: ${zoneRssi(bleSpan.zoneBCount, bleSpan.zoneBAvgRssi)}`}</div>
                    </div>
                </div>
                <div className="scan-summary-zone-item">
                    <span className="scan-summary-dot scan-summary-dot--red" />
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">{`Count: ${bleSpan.zoneCCount ?? '-'}`}</div>
                        <div className="asset-device-detail-container">{`Zone C (15m+) · RSSI: ${zoneRssi(bleSpan.zoneCCount, bleSpan.zoneCAvgRssi)}`}</div>
                    </div>
                </div>
            </div>
            <div className="asset-card-geolocation-container">
                <div className="asset-card-info-detail">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#475467" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />
                    </svg>
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">
                            {bleSpan.temperature != null ? `${Number(bleSpan.temperature).toFixed(1)} °C` : '-'}
                        </div>
                        <div className="asset-device-detail-container">Temperature</div>
                    </div>
                </div>
                <div className="asset-card-info-detail">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#475467" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
                    </svg>
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">
                            {bleSpan.humidity != null ? `${Number(bleSpan.humidity).toFixed(1)} %` : '-'}
                        </div>
                        <div className="asset-device-detail-container">Humidity</div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default ScanSummaryCard;
